module.exports = __webpack_public_path__ + "static/media/test9_1.766f14bc.png";